module.exports = __webpack_public_path__ + "static/media/eixo_dimensoes_sinaes.0e19adbd.png";